import { useContext } from 'react'

import { MinterContext } from './Context'

const useMinter = () => {
  const { minter, minterVersion1, minterVersion2 } = useContext(MinterContext)
  return { minter, minterVersion1, minterVersion2 }
}

export default useMinter
